// The patient profile: a single synced row with the fixed id 'profile' (SPEC.md §4.3).
import { useDbQuery } from '../db/hooks';
import type { DbClient } from '../db/client';
import type { Modality } from '../lib/schedule';

export const PROFILE_ID = 'profile';

export type AccessType = 'avf' | 'avg' | 'catheter';

export const ACCESS_LABELS: Record<AccessType, string> = {
  avf: 'Fistula (AVF)',
  avg: 'Graft (AVG)',
  catheter: 'Catheter'
};

export const MODALITY_LABELS: Record<Modality, string> = {
  in_center: 'In-center hemodialysis',
  home_hd: 'Home hemodialysis'
};

export interface Profile {
  full_name: string | null;
  dob: string | null;
  sex: string | null;
  blood_group: string | null;
  diagnosis: string | null;
  comorbidities: string | null;
  allergies: string | null;
  dialysis_start_date: string | null;
  modality: Modality | null;
  dry_weight_kg: number | null;
  access_type: AccessType | null;
  access_location: string | null;
  access_created_on: string | null;
  nephrologist_name: string | null;
  center_name: string | null;
  center_phone: string | null;
  emergency_contact_name: string | null;
  emergency_contact_phone: string | null;
}

export function useProfile() {
  const query = useDbQuery<Profile & { id: string }>('SELECT * FROM profile WHERE id = ? AND deleted_at IS NULL', [PROFILE_ID], ['profile']);
  return { profile: (query.data?.[0] as Profile | undefined) ?? null, isLoading: query.isLoading };
}

/** Saves only the given fields; others keep their current values. */
export function saveProfile(db: DbClient, patch: Partial<Profile>) {
  return db.upsert('profile', PROFILE_ID, patch);
}

export function firstName(profile: Profile | null) {
  return profile?.full_name?.trim().split(/\s+/)[0] ?? null;
}
